module.exports = __webpack_public_path__ + "images/120_4096.jpg";